import getValidFolderPaneWidth from './helpers/getValidFolderPaneWidth';
import { leftPaneResized } from '../actions/leftPaneResized';
import logFolderPaneState from '../helpers/logFolderPaneState';
import setFolderPaneWidth from '../legacyActions/setFolderPaneWidth';
import setShowFolderPane from '../mutators/setShowFolderPaneMutator';
import LayoutChangeSource from '../store/schema/LayoutChangeSource';
import getLeftRailWidth from '../utils/getLeftRailWidth';
import { createLazyOrchestrator } from 'owa-bundling';
import { getStore } from '../store/Store';

export const leftPaneResizedOrchestrator = createLazyOrchestrator(
    leftPaneResized,
    'CLONE_LEFTPANE_RESIZED',
    actionMessage => {
        /**
         * actionMessage.leftPaneWidth is the width of the entire left pane that contains left rail
         */
        const folderPaneWidthAfterResize = actionMessage.leftPaneWidth - getLeftRailWidth();

        /**
         *  Today upon left pane resize we are always showing the pane and never collapsing it.
         *  So upon resize event we should make sure we set the width to a valid number
         */
        const newFolderPaneWidth = getValidFolderPaneWidth(
            folderPaneWidthAfterResize,
            LayoutChangeSource.LeftNavResizeExpand
        );

        const isFolderPaneBeingShown = getStore().showFolderPane;
        setFolderPaneWidth(newFolderPaneWidth);
        setShowFolderPane(true); // Always expand upon left nav resize event

        if (!isFolderPaneBeingShown) {
            // User expanded the folder from collapsed state through resize, log this
            logFolderPaneState(
                LayoutChangeSource.LeftNavResizeExpand,
                true /* folderPaneNewShowState */,
                false /* folderPaneOldShowState */
            );
        }
    }
);
